import React from 'react';
import PropTypes from 'prop-types';
import AuthorAvatar from 'modules/Common/components/AuthorAvatar';

require('./AuthorTile.scss');

const AuthorTile = ({ name, type, image }) => (
    <div className="author-tile">
        <div className="author-tile__image">
          <AuthorAvatar image={image} size="small" />
        </div>
        <div>
            <div className="author-tile__name">{name}</div>
            <div className="author-tile__type">{type}</div>
        </div>
    </div>
);

AuthorTile.propTypes = {
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    image: PropTypes.string
};

AuthorTile.defaultProps = {
    image: ''
};

export default AuthorTile;



// WEBPACK FOOTER //
// ./modules/Common/components/TipsWidget/components/AuthorTile.js